export const VEHICLE_REGISTRATION_PROCESS_DESCRIPTION_ROUTE = 'opis-procesu';
